/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { Card, Form, Button, InputGroup, Row, Col } from 'react-bootstrap';
import { Error, Span, Star } from './styles';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import * as S from './styles';
import { FaArrowCircleLeft } from 'react-icons/fa';

export const SelectComp1 = (props: any) => {
  const [validated, setValidated] = useState(false);
  const { onChange, field, value, onGoBack, isBack, whoAmI } = props;
  const [selectForm, setselectForm] = useState(value);
  console.log('lkj->');
  const _renderSubmitButton = () => {
    return (
      <div
        className="mt-3"
        style={{ justifyContent: 'center', display: 'flex' }}
      >
        <Button
          variant="secondary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '25%',
            borderRadius: '0px',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {'Next'}
        </Button>
      </div>
    );
  };

  // const getFields = () => {
  //   if (whoAmI === 'prospective_employee') {
  //     return props?.selectFields?.filter((item: any) => {
  //       item?.value !== 'NEW_CSME_CERTIFICATE';
  //     });
  //   }
  //   return props?.selectFields;
  // };

  return (
    <div>
      {/* {isBack && (
        <Col lg={1} xs={2}>
          <S.Previous onClick={onGoBack}>
            <FaArrowCircleLeft />
          </S.Previous>{' '}
        </Col>
      )} */}
      <div style={{ justifyContent: 'center', display: 'flex' }}>
        <div style={{ width: '40%' }}>
          <TweetyWidget
            labelColor={'#104382'}
            fields={props?.selectFields}
            key={1}
            onFormSubmit={(payload: any) => {
              setselectForm(payload?.applicationType);
              onChange && onChange(payload?.applicationType);
            }}
            renderSubmitButton={_renderSubmitButton}
          />
        </div>
      </div>
    </div>
  );
};

SelectComp1.defaultProps = {
  field: {
    label: 'Application Type ',
    name: 'applicationType',
    notEmpty: {
      message: 'This field is required',
    },
    options: [
      {
        label: 'Select..',
        value: '',
      },
      // {
      //   label: "CARICOM Certificate - New",
      //   value: "caricomNew",
      // },
      // {
      //   label: "CARICOM Certificate - Verify",
      //   value: "caricomVerify",
      // },

      // {
      //   label: "CARICOM Right of Establishment",
      //   value: "caricomRightOfEstablishment",
      // },
      // {
      //   label: 'Work Permit - New',
      //   value: 'NEW_WORK_PERMIT',
      // },
      {
        label: 'Work Permit - Renewal',
        value: 'workPermitRenewal',
      },
      // {
      //   label: 'CSME',
      //   value: 'NEW_CSME_CERTIFICATE',
      // },
      // {
      //   label: 'Work Permit - Appeal',
      //   value: 'workPermitAppeal',
      // },
    ],
  },
  selectFields: [
    {
      type: 'select',
      compProps: {
        label: 'Application Type',
        id: 'applicationType',
        required: true,
        options: [
          // {
          //   label: 'Work Permit - New',
          //   id: 'NEW_WORK_PERMIT',
          // },
          // {
          //   label: 'Work Permit - Renewal',
          //   id: 'RENEW_WORK_PERMIT',
          // },
          {
            label: 'CSME',
            id: 'NEW_CSME_CERTIFICATE',
          },
          {
            label: 'CSME - Verification',
            id: 'CSME_VERIFICATION',
          },
          {
            label: 'Marriage Exemption',
            id: 'MARRIAGE_EXEMPTION',
          },
          {
            label: 'Rights of Establishment',
            id: 'RIGHTS_OF_ESTABLISHMENT',
          },
          // {
          //   label: 'CSME - Renewal',
          //   id: 'RENEW_CSME_CERTIFICATE',
          // },
        ],
      },
    },
  ],
};
